<template>
  <main>
    <b-navbar toggleable="lg" type="dark" variant="info" id="navbar" sticky>
      <b-navbar-brand href="#"><router-link to="/"><font-awesome-icon id="font" icon="arrow-left" /></router-link><span id="span">{{$t('bmi_assesment')}}</span></b-navbar-brand>
    </b-navbar>
    <b-container id="heading" class="mt-5">
      <p>{{$t('bmi_header')}}</p>
    </b-container>
    <b-container id="sub-heading" class="mt-5">
      <span>{{$t('bmi_header_2')}}</span>
    </b-container>
    <b-container class="mt-5">
      <b-avatar square variant="transparent" :src="require('../assets/Height.png')" size="4em"></b-avatar>
      <b-form-input v-model="height" class="inputField" type="number" min="0" :placeholder="$t('height')"></b-form-input>
    </b-container>
    <b-container class="mt-5">
      <b-avatar square variant="transparent" :src="require('../assets/Weight.png')" size="4em"></b-avatar>
      <b-form-input v-model="weight" class="inputField" type="number" min="0" :placeholder="$t('weight')"></b-form-input>
    </b-container>
    <b-container class="mt-5">
      <b-row>
      <b-col class="text-center"><b-button id="button" class="text-center" v-on:click="calculate(height, weight)"> {{$t('calculate_bmi')}}</b-button></b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import { mapActions } from 'vuex'
import router from '../router/index'
export default {
  name: 'BMIAssessmentInputs',
  data () {
    return {
      height: null,
      weight: null
    }
  },
  methods: {
    ...mapActions([
      'calculateBMI'
    ]),
    calculate (height, weight) {
      if (height <= 0 || height >= 300 || weight <= 0 || weight >= 200) {
        this.$toasted.error('Please enter valid height and weight', { position: 'bottom-center', duration: 5000 })
      } else {
        this.$toasted.clear()
        this.calculateBMI({ height: height, weight: weight })
        router.push('bmi-display')
      }
    }
  }
}
</script>
